import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import { IsMobileDevice } from "source/app/domain/Device/Helpers/IsMobile";
import { IGoalCardsProps } from "source/app/presentation/MainPanel/Goals/GoalCards/Helpers/IGoalCardsProps";
import { IGoalCardsState } from "source/app/presentation/MainPanel/Goals/GoalCards/Helpers/IGoalCardsState";
import { ShowGoalCard } from "source/app/presentation/MainPanel/Goals/GoalCards/Show/ShowGoalCard";
import { Style } from "source/app/presentation/Shared/Styles/CSS";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { SetState } from "source/app/services/UI/State/SetState";
import { State } from "source/app/services/UI/State/State";
import Data from "../../../../services/Data";
import MotwLogicServer from "../../../../services/External/LogicServer/MotwLogicServer";
import Nameof from "../../../../services/NameOf";
import { FadeInArray } from "../../../Shared/Animation/FadeInArray";
import { webkitFilterGlitchFix } from "../../../Shared/Styles/SharedStyles";
import {
    IsFilterGoalCardsSwitchEnabled
} from "../../Log/LogInputForm/LogInputForm";
import { AdjustWeeklyRates } from "./AdjustWeeklyRates/AdjustWeeklyRates";
import * as styles from "./GoalCards.css";

class GoalCards extends React.Component<IGoalCardsProps, IGoalCardsState> {
    constructor(props: IGoalCardsProps) {
        super(props);

        this.state = {
            recentRateChanges: [],
            gameIdentityScores: [],
            goalNamesLoggedToday: [],
            randomGoalCardId: 0,
        };
    }

    async componentDidMount() {
        await Data.Load.Component({
            component: this,
            load: MotwLogicServer.GetRecentRateChanges,
            stateTarget: Nameof<IGoalCardsState>("recentRateChanges"),
            inLoadAll: false,
        });

        State.ShareClass(ESharedComponent.GoalCards, this, {
            processedGoals: this.props.processedGoals,
        });
    }

    componentDidUpdate() {
        State.ShareClass(ESharedComponent.GoalCards, this, {
            processedGoals: this.props.processedGoals,
        });

        SetState(
            ESharedFunction.SelectRandomGoalCardFloatingTool_randomTime,
            new Date().toISOString()
        );
    }

    componentWillUnmount() {
        Data.Unload(this);
    }

    render() {
        if (
            this.props.goalStreakInfos.length === 0 ||
            !IsFilterGoalCardsSwitchEnabled()
        ) {
            return null;
        }

        const goalsToShow = this.props.processedGoals;

        const gameIdentityNames = this.state.gameIdentityScores.map((gis) =>
            gis.name.toLowerCase()
        );

        return (
            <div
                id="goalCards_container"
                className={styles.flexibleContainer}
                {...Style(
                    `goalCardsContainer_${
                        this.props.searchText
                    }_${IsMobileDevice()}`,
                    {
                        filter: IsMobileDevice()
                            ? `saturate(0.9) grayscale(0.1)`
                            : ``,
                        opacity: this.props.searchText !== "" ? 1.0 : 0.7,
                        padding: IsMobileDevice() ? "" : "10px 0px",

                        ...webkitFilterGlitchFix,
                    }
                )}
            >
                <AdjustWeeklyRates goalsToShow={goalsToShow} />
                <FadeInArray
                    label="goalsToShow"
                    array={goalsToShow}
                    render={(goal) => {
                        const goalStreakInfo = this.props.goalStreakInfos.find(
                            (gsi) => gsi.result_goalid === goal.id
                        )!;

                        return (
                            <ShowGoalCard
                                goal={goal}
                                goalDatapointLatest={this.props.goalDatapointsLatest.find(
                                    (gdpl) => gdpl.result_goalid === goal.id
                                )}
                                isLoggedToday={this.state.goalNamesLoggedToday.includes(
                                    goal.name
                                )}
                                isGameIdentityGoal={gameIdentityNames.includes(
                                    goal.name.toLowerCase()
                                )}
                                goalStreakInfo={goalStreakInfo}
                                randomGoalCardId={this.state.randomGoalCardId}
                            />
                        );
                    }}
                    itemDelayMs={25}
                    displayInline={true}
                />
            </div>
        );
    }
}

export default GoalCards;
